import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/DigitalTools/TrackingSystem/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('header__image-box')}>
        <img
          className={cn('header__image')}
          src="/images/pages/DigitalTools/TrackingSystem/bg-cloud.png"
          alt="Gradient background"
        />
      </div>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="dark"
          links={[
            { title: 'Digital Tools', href: '/digital-tools' as Route },
            { title: 'Tracking System', href: '' as Route },
          ]}
        />

        <div className={cn('header__logo-box')}>
          <img src="/images/pages/DigitalTools/TrackingSystem/logo.svg" alt="Tracking System Logo" />
        </div>
        <h1 className={cn('header__title')}>Real-Time Container Tracking System for Freight Management</h1>
        <p className={cn('header__description')}>
          The ultimate cargo tracking tool that works on any desktop or mobile device. Let your customers know where
          their cargo is and view it on the map without having to call you! Get access to tracking data from more than
          160 shipping carriers.
        </p>

        <div className={cn('header__image-desktop-box')}>
          <img
            className={cn('header__image-desktop')}
            src="/images/pages/DigitalTools/TrackingSystem/safari-white.svg"
            alt="Container Tracking System"
          />
        </div>
        <div className={cn('header__image-tablet-box')}>
          <img
            className={cn('header__image-tablet')}
            src="/images/pages/DigitalTools/TrackingSystem/safari-white-768.svg"
            alt="Container Tracking System in China"
          />
        </div>
        <div className={cn('header__image-mobile-box')}>
          <img
            className={cn('header__image-mobile')}
            src="/images/pages/DigitalTools/TrackingSystem/safari-white-mobile.svg"
            alt="Container Tracking System in China"
          />
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;